// Import your browserEnv normally
const browserEnv = require('./utils/browser-env');

const polyfills = {
  window: typeof window !== 'undefined' ? window : browserEnv.window,
  document: typeof document !== 'undefined' ? document : browserEnv.document,
  navigator: typeof navigator !== 'undefined' ? navigator : browserEnv.navigator,
  Element: typeof Element !== 'undefined' ? Element : browserEnv.Element,
  HTMLElement: typeof HTMLElement !== 'undefined' ? HTMLElement : browserEnv.HTMLElement,
  applyPolyfills() {
    return browserEnv;
  }
};

module.exports = polyfills;
